import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useEffect } from 'react';
import { useCommandBus } from "./useCommandBus";

/**
 * TODO: Might want some of this added to eslint
 *   "react-hooks/exhaustive-deps": ["warn", {
 *     "additionalHooks": ["useBusListener", "useBusCmdListener"]
 *   }]
 */
export var useBusListener = function useBusListener(commandType, handler) {
  var dependencies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var bus = useCommandBus();
  useEffect(function () {
    bus.on(commandType, handler);
    return function () {
      return bus.off(commandType, handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commandType].concat(_toConsumableArray(dependencies)));
};